import { useTheme } from './theme';
import cognitiveUxLogo from '../images/scalex_ai_logo.png';
import almondMark from '../images/almond_mark.png';

// The product's name and logo follow the theme: the Green appearance (the
// default since 2026-09-24) is Almond, Classic blue keeps CognitiveUX.ai.
// theme.js swaps the tab title and favicon; components read useBrand() for
// the sidebar, the mobile header and the sign-in pages.
//
// `markOnDark` says whether the logo needs a dark backdrop: the Almond mark is
// a transparent pixel brain whose top rows are near-white, so on a light
// surface it sits in a Forest chip (see components/memory/AlmondMark.jsx).

export const BRANDS = Object.freeze({
  blue: Object.freeze({ name: 'CognitiveUX.ai', logo: cognitiveUxLogo, favicon: '/scalex_ai_logo.png', touchIcon: '/scalex_ai_logo.png', markOnDark: false }),
  green: Object.freeze({ name: 'Almond', logo: almondMark, favicon: '/almond_favicon.png', touchIcon: '/almond_touch.png', markOnDark: true }),
});

export function brandFor(theme) {
  return BRANDS[theme] || BRANDS.green;
}

/** The current theme's brand; re-renders when the theme changes. */
export function useBrand() {
  const [theme] = useTheme();
  return brandFor(theme);
}
